export const TrailNotes = ({notes}) => {
  return (
    <>
      <h1 className="text-gray-900 font-sans text-xl font-semibold leading-[30px] gap-1">
        Note
      </h1>
      <p className="text-gray-700 font-sans text-[16px] font-[500] leading-6 break-words">
        {notes}
      </p>
    </>
  );
};
